import Vue from 'vue';
import Vuex from 'vuex';
import home from './home-store';
import testService from './test-service-store';
Vue.use(Vuex);
import service from '../utils/service';

Vuex.Store.prototype.service = service;
export default new Vuex.Store({
    state: {
        userInfo: {},
        sampleType: [],
        dataUsage: [],
        otherCategories: [],
        reportSignature: [],
        sampleUnit: [],
        spinning: false,
        originSampleType: [],
        unitSelect: []
    },

    getters: {
        userInfo(state) {
            if (JSON.stringify(state.userInfo) === '{}') {
                const infoStr = sessionStorage.getItem('userInfo');
                return JSON.parse(infoStr);
            }
            return state.userInfo;
        },

        isLogin(state) {
            return Object.keys(state.userInfo).length > 0;
        }
    },

    actions: {
        getSampleType(context, isCigarette = false) {
            this.service.get('/secure/css/action/select-sample-type?businessTypeCode_SEQ=T').then(({
                data
            }) => {
                context.commit('setOriginSampleType', data);
                context.commit('setSampleType', isCigarette);
            });
        },

        getDataUsage(context) {
            this.service.get('/secure/css/action/dataUsage/select-core-code').then(({
                data
            }) => {
                context.commit('setDataUsage', data);
            });
        },
        // 单位参数
        getUnitSelect(context) {
            this.service.get('/secure/css/action/dataUsage/select-core-code').then(({
                data
            }) => {
                context.commit('setUnitSelect', data);
            });
        },

        getOtherCategories(context) {
            this.service.get('/secure/css/action/otherCategories/select-core-code').then(({
                data
            }) => {
                context.commit('setOtherCategories', data);
            });
        },

        getReportSignature(context) {
            this.service.get('/secure/css/action/reportSignature/select-core-code').then(({
                data
            }) => {
                context.commit('setReportSignature', data);
            });
        },

        getSampleUnit(context, sampleType) {
            this.service
                .post(
                    '/secure/css/action/units/queries-by-sampleType',
                    JSON.stringify({
                        p: {
                            f: {
                                SCATEGORYCODE_SEQ: sampleType
                            }
                        },
                        b: null
                    })
                )
                .then(({
                    data
                }) => {
                    context.commit('setSampleUnit', data);
                });
        },

        signOut(context, callback) {
            /* this.service.post('/core/module/sys/logout').then(() => {
                sessionStorage.removeItem('userInfo');
                context.commit('setUserInfo', {});
                callback?.();
            });*/
            this.service.post('/kcauth/logout').then(() => {
                sessionStorage.removeItem('userInfo');
                context.commit('setUserInfo', {});
                callback?.();
            });
        }
    },

    mutations: {
        setUserInfo(state, data) {
            state.userInfo = data;
        },

        setSampleType(state, isCigarette) {
            const data = isCigarette ?
                state.originSampleType.filter(item => item.dzyFlag === '1') :
                state.originSampleType;
            state.sampleType = data.map(d => {
                return {
                    label: d.sampleTypeName,
                    value: d.sampleTypeCode
                };
            });
        },

        setOriginSampleType(state, t) {
            state.originSampleType = t;
        },

        setDataUsage(state, data) {
            state.dataUsage = data.map(d => {
                return {
                    label: d.codeName,
                    value: d.code
                };
            });
        },

        setUnitSelect(state, data) {
            state.unitSelect = data.map(d => {
                return {
                    label: d.codeName,
                    value: d.code
                };
            });
        },

        setOtherCategories(state, data) {
            state.otherCategories = data.map(d => {
                return {
                    label: d.codeName,
                    value: d.code
                };
            });
        },

        setReportSignature(state, data) {
            state.reportSignature = data.map(d => {
                return {
                    label: d.codeName,
                    value: d.code
                };
            });
        },

        setSampleUnit(state, data) {
            state.sampleUnit = data.map(d => {
                return {
                    label: d.unitName,
                    value: d.code
                };
            });
        },

        changeSpinning(state, sp) {
            state.spinning = sp;
        }
    },

    modules: {
        home,
        testService
    }
});